import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

import ItemForm from "./form/ItemForm"
import BlogMenuDragLayer from "./BlogMenuDragLayer"
import BlogMenuList from "./BlogMenuList"
import { afterSave } from '../../actions/design/blogmenu'
import { jsonResponseHandler } from '../../utils/FetchHelper'
import TSubmitButtonForm from "../common/TSubmitButtonForm";
import * as SaveStatus from '../../constants/SaveStatus'
import {addPrefix, isDaumBlogDomain} from "../../utils/UriUtil";

function BlogMenuNotice() {
  const isEditableMenu = useSelector(state => state.blogmenu.isEditableMenu)
  if (isEditableMenu) {
    return null
  }

  return (
    <div className="noti_menu">
      <span className="wrap_ico"><span className="ico_blog ico_noti"/></span>
      <p>
        지금 사용하시는 스킨은 메뉴를 지원하지 않습니다.<br />
        메뉴를 지원하는 스킨으로 변경후 사용하시기 바랍니다.
        { !isDaumBlogDomain() && (
          <a href="http://notice.tistory.com/2392" className="info_sub" target="_blank">자세히 보기</a>
        )}
      </p>
    </div>
  )
}


export default function BlogMenuForm() {
  const menus = useSelector(state => state.blogmenu.menus)
  const changed = useSelector(state => state.blogmenu.changed)
  const previewForm = useRef(null)

  const [saveStatus, setSaveStatus] = useState(SaveStatus.READY)
  const dispatch = useDispatch()

  useEffect(() => {
    if (changed) {
      setSaveStatus(SaveStatus.CAN_SUBMIT)
    }
  }, [changed])

  function handlePreview() {
    window.open("about:blank", "preview")
    previewForm.current.submit()
  }

  function handleSave() {
    const prevStatus = saveStatus
    setSaveStatus(SaveStatus.DOING)
    fetch(addPrefix("/manage/design/menu.json"), {
      method: "post",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        menus
      })
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => {
        setSaveStatus(SaveStatus.DONE)
        dispatch(afterSave())
      })
      .catch(e => {
        setSaveStatus(prevStatus)
        console.error(e)
        alert("문제가 발생했습니다.")
      })
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="wrap_set">
        <strong className="tit_set">블로그에 메뉴를 추가/삭제하고 순서를 변경할 수 있습니다.</strong>
        <p className="desc_info">드래그 앤 드롭으로 메뉴 위치를 변경할 수 있습니다.</p>

        <BlogMenuNotice />

        <div className="set_order">
          <div className="wrap_order">
            <strong className="screen_out">블로그 메뉴 목록</strong>
            <BlogMenuList menus={menus} />
            <ItemForm />
            <BlogMenuDragLayer />
          </div>
        </div>
        <div className="set_btn">
          <div className="bunddle_preview">
            <button type="button" className="btn_preview" onClick={handlePreview}>미리보기 <span className="ico_blog">새창으로 열기</span></button>
            <TSubmitButtonForm status={saveStatus} onClick={handleSave} />
          </div>
        </div>

        <form ref={previewForm} action={addPrefix("/manage/previewMenu.php")} method="post" target="preview">
          <input type="hidden" name="menus" value={JSON.stringify(menus)} />
        </form>
      </div>
    </DndProvider>
  )
}
